import { render, staticRenderFns } from "./Legenda.vue?vue&type=template&id=08ccb657&scoped=true&lang=pug&"
import script from "./Legenda.vue?vue&type=script&lang=ts&"
export * from "./Legenda.vue?vue&type=script&lang=ts&"
import style0 from "./Legenda.vue?vue&type=style&index=0&id=08ccb657&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ccb657",
  null
  
)

export default component.exports